import { browserPushUrl } from '@/utils';
import CampaignBase from '../../CampaignBase';

// const disabledC = ['CN'];
const TradeUpOfflineC = ['US', 'JP', 'CN'];

/**
 * @description 2024长期促销活动
 * https://arashivision.feishu.cn/wiki/NQCvw1oHIi7nhxks4UichY8Onrb
 */

class LongTermDiscount extends CampaignBase {
  constructor(props) {
    super(props);
    // ace pro 暂时禁用limited offer - 09/23-X3、GO3、flow、link,19、24、22、18删除长期折扣文案
    this.enableProduct = [13, 15, 25];
    this.timeConfig = {
      now: new Date().getTime(),
      start: 0,
      // start:1679394600000  2023-03-21 18:30:00
    };
    this.enabled = this.timeConfig.now > this.timeConfig.start;
  }

  // 获取套餐标签，删掉limitOffer
  getCommodityLabel = (commodity, currentLabels) => {
    return {
      replaceLabels:
        this?.enableProduct?.includes(commodity.product) && currentLabels.filter((d) => d?.tagName !== 'limitedOffer'),
    };
  };

  // enabled = () => {
  //   const now = new Date().getTime();
  //   return now > this.timeConfig.start;
  // };

  // 产品页是否展示
  enableProductPage = (productInfo = {}, from = 'page') => {
    const { pid } = productInfo;
    // const { code } = this.country;
    switch (from) {
      case 'discountIntro':
      case 'intro':
        return this.enabled;
      case 'tag':
        return this.enabled && this.enableProduct.includes(pid);
      case 'tradeup':
        return this.enabled &&
          // 大陆只有X2折扣
          this.country?.code === 'CN'
          ? [13].includes(pid)
          : this.enableProduct.includes(pid) && TradeUpOfflineC?.includes(this?.country?.code);
      default:
        return false;
    }
  };

  getTradeUp = (curType) => {
    const { urlKey } = curType;

    return {
      title: this.LANG['activity.2024LongTermDiscount.trade_title'] ?? '',
      content: this.LANG['activity.2024LongTermDiscount.trade_content'] ?? '',
      confirmText: this.LANG['activity.2024LongTermDiscount.trade_button'] ?? '',
      onConfirm: () => browserPushUrl(`/product/${urlKey}?from=tradeup`),
    };
  };

  getProductDiscountIntro = ({ pid }) => {
    let text = '';
    switch (true) {
      case [13].includes(pid):
        text = this.LANG['activity.2024LongTermDiscount.x2_marketing_text'];
        if (
          [
            'GB',
            'CH',
            'SE',
            'ES',
            'SI',
            'SK',
            'RO',
            'PT',
            'PL',
            'NO',
            'NL',
            'MC',
            'MT',
            'LU',
            'LT',
            'LI',
            'LV',
            'IT',
            'IE',
            'IS',
            'HU',
            'GR',
            'DE',
            'FR',
            'FI',
            'EE',
            'DK',
            'CZ',
            'CY',
            'HR',
            'BG',
            'BE',
            'AT',
            'RU',
            'AD',
          ].includes(this.country.code)
        ) {
          text = this.LANG['activity.2024LongTermDiscount.x2_special_marketing_text'];
        }
        break;
      case [15].includes(pid):
        text = this.LANG['activity.2024LongTermDiscount.rs_marketing_text'];
        break;
      default:
        break;
    }
    return { text: text, isTop: true };
  };
}

export default LongTermDiscount;
